import { getDocsWebsite } from "~/utils/docsapi";

export const revalidateDocument = async ({
	input: { workspaceName, documentId, skip },
}: {
	input: { workspaceName: string; documentId: string; skip: boolean };
}) => {
	if (skip) {
		return;
	}

	const res = await fetch(`${getDocsWebsite()}/api/revalidate/${workspaceName}/${documentId}`);
	if (!res.ok) {
		throw new Error("Failed to revalidate document");
	}
};
